import { Tab, Tabs, Typography } from '@mui/material';

import { useTranslation } from 'modules/i18n/hooks/useTranslation';
import { ESettingsNavTab } from 'modules/layout/const';
import spacer from 'modules/layout/assets/spacer.svg';
import { useAuth } from 'modules/auth/hooks/useAuth';

import { useSettingsNavTabsStyles } from './useSettingsNavTabsStyles';
import { settingsNavTabsTranslation } from './translation';
import { useSettingsNavTabs } from './useSettingsNavTabs';

export const SettingsNavTabs = () => {
  const { classes, cx } = useSettingsNavTabsStyles();

  const { keys, t } = useTranslation(settingsNavTabsTranslation);

  const { isWeb3Auth } = useAuth();

  const { currentTab, handleChangeTab } = useSettingsNavTabs();

  return (
    <div className={classes.mainRoot}>
      <div className={classes.root}>
        <Tabs
          value={currentTab}
          variant="scrollable"
          onChange={handleChangeTab}
        >
          <Tab
            value={ESettingsNavTab.platform}
            label={
              <Typography variant="subtitle2" color="textSecondary">
                {t(keys.platform)}
              </Typography>
            }
            className={classes.tab}
          />
          {!isWeb3Auth && (
            <Tab
              value={ESettingsNavTab.swagger}
              label={
                <Typography variant="subtitle2" color="textSecondary">
                  {t(keys.swagger)}
                </Typography>
              }
              className={classes.tab}
            />
          )}
          <Tab
            disabled
            label={<img alt="logo" src={spacer} />}
            className={cx(classes.tab, classes.dividerTab)}
          />
          <Tab
            value={ESettingsNavTab.general}
            label={
              <Typography variant="subtitle2" color="textSecondary">
                {t(keys.general)}
              </Typography>
            }
            className={classes.tab}
          />
          <Tab
            value={ESettingsNavTab.teammates}
            label={
              <Typography variant="subtitle2" color="textSecondary">
                {t(keys.teammates)}
              </Typography>
            }
            className={classes.tab}
          />
          <Tab
            value={ESettingsNavTab.notifications}
            label={
              <Typography variant="subtitle2" color="textSecondary">
                {t(keys.notifications)}
              </Typography>
            }
            className={classes.tab}
          />
        </Tabs>
      </div>
    </div>
  );
};
